import type { FC } from 'react';

import type { GenericSvgIconProps } from '../CustomIcon';

/** Custom Arrow Icon for LocaleDropdownButton on snap.com homepage */
export const ArrowIcon: FC<GenericSvgIconProps> = props => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill="#000"
        d="M11 20a1 1 0 1 0 2 0h-2Zm1.707-16.707a1 1 0 0 0-1.414 0L4.929 9.657a1 1 0 0 0 1.414 1.414L12 5.414l5.657 5.657a1 1 0 0 0 1.414-1.414l-6.364-6.364ZM12 20h1V4h-2v16h1Z"
      />
    </svg>
  );
};
